import React, { Fragment } from 'react';
import _ from 'lodash';

import { FormDropdownRadio, FormElement } from '../../CommonFormComponents';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import { FieldTreeSubWorkTypesDropdown } from './FieldTreeSubWorkTypesDropdown';
import ProgressService from '../../../services/Progress';
import WorkScheduleService from '../../../services/Works';
import SessionStorageService from '../../../services/utilities/SessionStorageService';

/**
 * @export
 * @class FieldTreeSubWorkTypesDropdownHistory
 * @props {string} error
 * @props {string} value
 * @props {string} name
 * @props {number} mainWorkTypeId
 * @props {function} setValueSubWorkTypes
 * @props {boolean} disabledDropdown
 * @props {boolean} readOnly
 * @props {function} validate
 * @props {function} set
 * @props {string} column
 * @props {number} keySubWork
 * @props {number} foremanUserId
 * @props {boolean} isFormListDefault
 * @props {function} onLoadDataSub
 * @props {number} resetKeys
 * @props {boolean} isEdit
 * @extends {React.Component}
 */
export class FieldTreeSubWorkTypesDropdownHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      opened: false,
      selected: null,
      options: {},
      isLoading: true,
    };

    this.id = _.uniqueId();
    this.parent = React.createRef();
    this.isLoaded = false;
    this.isDiffForeman = false;
    this.prevMainWorkTypeId = null;
    this.prevGetFieldSubWorkTypesParams = {};
    this.prevFieldSubWorkTypesPromise = null;
    this.isCopyReport = false;
  }

  componentDidMount() {
    if (
      this.props.foremanUserId &&
      this.props.mainWorkTypeId &&
      !this.props.isEdit &&
      this.props.isFirstTimeGetHistories
    ) {
      this.getHistories();
    } else if (this.props.listHistoriesSub && !this.props.isEdit) {
      this.setOptionHistories(this.props.listHistoriesSub);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened) {
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    } else {
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }

    if (this.props.isCopy) {
      this.isCopyReport = true;
    }

    if (
      !_.isEqual(prevProps.resetKeys, this.props.resetKeys) &&
      !_.isNull(this.props.foremanUserId)
    ) {
      this.isLoaded = false;
      if (!this.props.isEdit) {
        this.getHistories();
        this.isDiffForeman =
          !_.isEqual(prevProps.foremanUserId, this.props.foremanUserId) ||
          _.isNull(prevProps.mainWorkTypeId) ||
          this.isCopyReport;
      }
    }
  }

  /**
   * Override method
   */
  handleClickOutsideOfComponent = e => {
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    this.setState({ opened: false });
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  handleSelectedRow = (id, checked) => {
    let selected = '';
    if (checked) {
      selected = id;
    }
    this.setState({ selected }, () => {
      this.props.set(this.props.column, selected, true);
      this.handleOpen();
    });
    const nameWork = _.find(
      this.state.options,
      item => item.sub_work_type_id === parseInt(id)
    ).sub_work_type_name;
    const requirePlace = _.find(
      this.state.options,
      item => item.sub_work_type_id === parseInt(id)
    ).required_item_list_ids;
    this.setValueSubWorkTypes(id, nameWork, requirePlace);
  };

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  setValueSubWorkTypes = (id, name, requirePlace, isResetRequired) => {
    this.props.setValueSubWorkTypes(id, name, requirePlace, isResetRequired);
  };

  handleOpen = () => {
    if (!this.state.opened && !this.isLoaded) {
      this.setState({
        selected: null,
        options: {},
        isLoading: false,
      });
      if (this.props.isEdit) {
        this.setState({ isLoading: true }, () => this.getHistories());
      }
    }
    if (this.state.opened && _.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
    this.setState({ opened: !this.state.opened });
  };

  getHistories = async () => {
    if (this.isLoaded) {
      this.setState({ isLoading: false });
      return;
    }

    const histories = await this.getWorksHistories(this.state.fieldId);
    if (!this.props.isEdit) {
      this.props.setListHistoriesSubWork(histories);
    }
    this.setOptionHistories(histories);
  };

  setOptionHistories = listHistoriesSub => {
    const formatName = option => {
      const { duplicate_name_flag, template_name, sub_work_type_name } = option;
      return duplicate_name_flag
        ? `${sub_work_type_name}（${template_name}）`
        : sub_work_type_name;
    };
    const options = _.map(listHistoriesSub, option => ({
      ...option,
      sub_work_type_name: formatName(option),
    }));
    this.setState({ options, isLoading: false });
    this.isLoaded = true;
  };

  getWorksHistories = async fieldId => {
    if (!this.props.foremanUserId || !this.props.mainWorkTypeId) {
      return null;
    }
    const params = {
      foreman_user_id: this.props.foremanUserId,
      main_work_type_id: this.props.mainWorkTypeId,
      column: this.props.column,
    };

    const response = await WorkScheduleService.histories(fieldId, params);
    if (response.result) {
      this.setState({ selected: null });
      if (!this.props.isEdit) {
        if (!_.size(_.get(response.data, 'entities.works'))) {
          this.setValueSubWorkTypes(null, null, null, true);
        }
        if (
          _.size(_.get(response.data, 'entities.works')) &&
          this.isDiffForeman
        ) {
          const {
            sub_work_type_id,
            sub_work_type_name,
            required_item_list_ids,
          } = _.get(response.data, 'entities.works[0]');
          this.setValueSubWorkTypes(
            sub_work_type_id,
            sub_work_type_name,
            required_item_list_ids
          );
          this.setState({ selected: sub_work_type_id });
        }
        this.isCopyReport = false;
      }
      return _.get(response.data, 'entities.works');
    }
  };

  getFieldSubWorkTypes = params => {
    // 連続して同じパラメタの場合はキャッシュを利用する
    const getFieldSubWorkTypesParams = {
      ...params,
      main_work_type_id: this.props.mainWorkTypeId,
      include_other_flag: 1,
    };
    if (
      JSON.stringify(getFieldSubWorkTypesParams) ===
      JSON.stringify(this.prevGetFieldSubWorkTypesParams)
    ) {
      return this.prevFieldSubWorkTypesPromise;
    }

    const res = ProgressService.getProgressFieldSubWorkTypes(
      this.state.fieldId,
      getFieldSubWorkTypesParams
    );
    this.prevGetFieldSubWorkTypesParams = getFieldSubWorkTypesParams;
    this.prevFieldSubWorkTypesPromise = res;
    return res;
  };

  render() {
    const { editTableError, validationClassname } = this.props;
    return (
      <FormElement validate={this.props.error}>
        {this.props.readOnly ? (
          <div>{this.props.name}</div>
        ) : (
          <Fragment>
            <FieldTreeSubWorkTypesDropdown
              key={this.props.keySubWork}
              label='小工種を選択'
              selectorName='name'
              api={this.props.mainWorkTypeId ? this.getFieldSubWorkTypes : null}
              apiSearchKey='name'
              selectedValues={
                _.isNull(this.props.value) ? '' : String(this.props.value)
              }
              selectedName={_.defaultTo(this.props.name, '')}
              limit={REQUEST_PARAMS.parentLimitPartnerCompanyBranchDropdown}
              keyName='name'
              valueName='sub_work_type_id'
              apiBindDataKey={'field_sub_work_types'}
              onSelect={(name, values) => {
                this.setValueSubWorkTypes(values);
              }}
              validate={this.props.validate}
              set={this.props.set}
              column={this.props.column}
              strictEqual={true}
              reloadOptions={false}
              dropdownSelectStyle={{ width: '238px' }}
              disabledDropdown={this.props.disabledDropdown}
              isSubTypeRequired={this.props.isSubTypeRequired}
              isFormListDefault={this.props.isFormListDefault}
              readOnly={this.props.readOnly}
              onLoadData={this.props.onLoadDataSub}
              sorted={true}
            />
            <div
              id='form-dropdown'
              className='dropdown-multi-select dropdown-multi-select__history-search form-list__element--btn'
              ref={this.parent}
            >
              <div
                className={`dropdown-multi-select__header ${
                  this.props.editTableError
                    ? 'dropdown-multi-select__history--error'
                    : ''
                }`}
              >
                <button
                  id='form-dropdown-btn'
                  className={
                    this.props.disabledDropdown
                      ? 'btn-fixedsize--sub'
                      : 'btn-fixedsize--disabled'
                  }
                  onClick={() => this.handleOpen()}
                  disabled={!this.props.disabledDropdown}
                >
                  履歴から選択
                </button>
                {editTableError && (
                  <div className={`${validationClassname}`}>
                    {editTableError}
                  </div>
                )}
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                    <div className='dropdown-multi-select__item'>
                      <div className='dropdown-multi-select__scroll'>
                        <ul className='single-select'>
                          {this.state.isLoading && (
                            <div className='indicator' />
                          )}
                          {this.state.isLoading ? null : _.size(
                              this.state.options
                            ) > 0 ? null : (
                            <div className='table-has-no-data'>
                              <div className='table-has-no-data__message'>
                                {messageUtility.getMessage('I-000-046')}
                              </div>
                            </div>
                          )}
                          {_.map(this.state.options, option => (
                            <FormDropdownRadio
                              key={option.id}
                              option={option}
                              checked={
                                this.state.selected ===
                                option[this.props.column]
                              }
                              targetId={this.id}
                              column={this.props.column}
                              handleSelectedRow={this.handleSelectedRow}
                              forId={'single-latest-registration-history'}
                            >
                              {option.sub_work_type_name}
                            </FormDropdownRadio>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Fragment>
        )}
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreeSubWorkTypesDropdownHistory.jsx